import React from "react";
import { isMatchPromoValid, isPromoLinkValid, useMatchData } from "../../utils";
import SupportCopyCompact from "../../../shared/components/SponsorV2/SupportCopyCompact/SupportCopyCompact";
import MatchPromo from "../../../shared/components/SponsorV2/MatchPromo/MatchPromo";
import {
  StyledMatchListPromo,
  StyledMatchListPromoDivider,
  StyledMatchPromoLinksWrapper,
  StyledMatchPromoWrapper,
  StyledPromoMiscWrapper,
  StyledSupportCopyCompactPromoWrapper,
} from "./StyledMatchListPromo";
import MatchPromoLink from "../../../shared/components/SponsorV2/MatchPromo/MatchPromoLink/MatchPromoLink";
import MatchPromoButton from "../../../shared/components/SponsorV2/MatchPromo/MatchPromoButton/MatchPromoButton";
import { useReactAppState } from "../../../shared/containers/utils";

function MatchListPromo() {
  const { promoInfo } = useMatchData();
  const { t } = useReactAppState();

  const {
    matchPromo,
    promotionalSponsor,
    sponsorImage,
    promotionalStay,
    promotionalFly,
    promotionalRide,
    promotionalMisc1,
    promotionalMisc2,
  } = promoInfo || {};
  const { displayText } = promotionalSponsor || {};
  const { assetUrl } = sponsorImage || {};

  const hasMatchPromo = isMatchPromoValid(matchPromo);
  const hasPromotionalSponsor = assetUrl || displayText;
  const hasPromoMisc =
    isPromoLinkValid(promotionalMisc1) || isPromoLinkValid(promotionalMisc2);
  const hasExtraPromotions =
    isPromoLinkValid(promotionalStay) ||
    isPromoLinkValid(promotionalFly) ||
    isPromoLinkValid(promotionalRide);

  if (
    !hasMatchPromo &&
    !hasPromotionalSponsor &&
    !hasPromoMisc &&
    !hasExtraPromotions
  ) {
    return null;
  }

  const showMatchPromoDivider = hasMatchPromo && hasPromotionalSponsor;
  const showPromoMiscDivider =
    hasPromoMisc && (hasMatchPromo || hasPromotionalSponsor);
  const showExtraPromoDivider =
    hasExtraPromotions &&
    (hasMatchPromo || hasPromotionalSponsor || hasPromoMisc);

  return (
    <StyledMatchListPromo className="mls-c-match-list-promo">
      {hasPromotionalSponsor && (
        <StyledSupportCopyCompactPromoWrapper>
          <SupportCopyCompact displayText={displayText} assetUrl={assetUrl} />
        </StyledSupportCopyCompactPromoWrapper>
      )}
      {showMatchPromoDivider && <StyledMatchListPromoDivider />}
      <StyledMatchPromoWrapper>
        {hasMatchPromo && (
          <MatchPromo
            headline={matchPromo.headline}
            description={matchPromo.description}
            callToAction1={matchPromo.callToAction1}
            callToAction2={matchPromo.callToAction2}
          />
        )}
      </StyledMatchPromoWrapper>

      {showPromoMiscDivider && <StyledMatchListPromoDivider />}
      <StyledPromoMiscWrapper>
        {hasPromoMisc && (
          <>
            {promotionalMisc1 && (
              <MatchPromoButton callToAction={promotionalMisc1} />
            )}
            {promotionalMisc2 && (
              <MatchPromoButton callToAction={promotionalMisc2} />
            )}
          </>
        )}
      </StyledPromoMiscWrapper>

      {showExtraPromoDivider && <StyledMatchListPromoDivider />}
      {hasExtraPromotions && (
        <StyledMatchPromoLinksWrapper>
          {promotionalStay && (
            <MatchPromoLink
              callToAction={promotionalStay}
              prefix={t("match_promo_hotel")}
            />
          )}
          {promotionalFly && (
            <MatchPromoLink
              callToAction={promotionalFly}
              prefix={t("match_promo_fly")}
            />
          )}
          {promotionalRide && (
            <MatchPromoLink
              callToAction={promotionalRide}
              prefix={t("match_promo_travel")}
            />
          )}
        </StyledMatchPromoLinksWrapper>
      )}
    </StyledMatchListPromo>
  );
}

export default MatchListPromo;
